export default __webpack_public_path__ + "static/media/main-img1.f783b0bd.png";